// ============================================================================
// ErrorMessage Component - Error state display with retry
// ============================================================================
// Displays error messages with optional retry button
// ============================================================================

interface ErrorMessageProps {
  message: string
  onRetry?: () => void
  showRetry?: boolean
}

export default function ErrorMessage({ message, onRetry, showRetry = true }: ErrorMessageProps) {
  return (
    <div className="error-message-container">
      <div className="error-message">
        <div className="error-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2" />
            <line x1="12" y1="8" x2="12" y2="12" strokeWidth="2" strokeLinecap="round" />
            <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <h3 className="error-title">Something went wrong</h3>

        <p className="error-text">{message}</p>

        {showRetry && onRetry && (
          <button
            className="btn btn-primary"
            onClick={onRetry}
            style={{ marginTop: '1rem' }}
          >
            Try Again
          </button>
        )}
      </div>

      <style>{`
        .error-message-container {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 300px;
          padding: 2rem;
        }

        .error-message {
          text-align: center;
          max-width: 400px;
        }

        .error-icon {
          color: var(--error-red, #ef4444);
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
        }

        .error-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: var(--text-primary);
          margin-bottom: 0.5rem;
        }

        .error-text {
          color: var(--text-secondary);
          line-height: 1.6;
          margin-bottom: 0;
        }
      `}</style>
    </div>
  )
}
